/**
 * Per-casino POP (Payout to Player) visibility.
 *
 * Driven only by the `showPOP` field on the casino object (Mongo `casinos`,
 * passed through GetAllCasinos as-is and persisted as `casinoSchema`).
 *
 * - 1, '1' or true            -> show POP
 * - 0, '0', false, missing,
 *   null or anything else      -> hide POP (default is hidden)
 *
 * Display-only: callers hide POP labels/values in the UI. Insight rows,
 * summary responses and caches are not touched. No casino ids are hardcoded.
 */
export type ShowPopCasino = { showPOP?: unknown } | null | undefined;

export const isShowPopValue = (value: unknown): boolean => {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') return value.trim() === '1';
  return false;
};

export const shouldShowPop = (casino: ShowPopCasino): boolean =>
  !!casino && typeof casino === 'object' && isShowPopValue(casino.showPOP);
